import { render, staticRenderFns } from "./CampFloatingBtn.vue?vue&type=template&id=54c459b4&scoped=true&"
import script from "./CampFloatingBtn.vue?vue&type=script&lang=js&"
export * from "./CampFloatingBtn.vue?vue&type=script&lang=js&"
import style0 from "./CampFloatingBtn.vue?vue&type=style&index=0&id=54c459b4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54c459b4",
  null
  
)

export default component.exports